import { useInteractions } from "@floating-ui/react";
import { createContext } from "react";

export type DropdownContextValue = {
  activeIndex: number | null;
  selectedIndex: number | null;
  getItemProps: ReturnType<typeof useInteractions>["getItemProps"];
  handleSelect: (index: number | null) => void;
};

export const DropdownContext = createContext<DropdownContextValue>(
  {} as DropdownContextValue,
);
